__turbopack_context__.v({
  "bubble": "NationwideSearchExpander-module-scss-module__w7lpOW__bubble",
  "search-expansion-prompt": "NationwideSearchExpander-module-scss-module__w7lpOW__search-expansion-prompt",
});
